import { VInput } from 'vuetify/lib/components/VInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VInput,_vm._b({},'v-input',_vm.$attrs,false),[_c('file-pond',_vm._b({ref:"filepond",class:{ multiple: _vm.allowMultiple },staticStyle:{"width":"100%"},attrs:{"label-idle":_vm.dropzoneText,"allow-multiple":_vm.allowMultiple,"image-preview-height":"250","label-file-type-not-allowed":_vm.$t('fresh-vue-files.FileDropzone.file-type-not-allowed'),"file-validate-type-label-expected-types":`${_vm.$t(
      'fresh-vue-files.FileDropzone.file-type-expected'
    )} {allTypes}`},on:{"updatefiles":_vm.onUpdateFiles}},'file-pond',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }